// extracted by css-extract-rspack-plugin
export default {"container":"PolicyIconContainer-module__container"};